import { API_INSTANCE, fullBuildURL } from 'src/features/utils';
import * as T from './types';

export const fetchWidgetDataApi = async (payload: T.FetchWidgetApiPayload) => {
  return API_INSTANCE.get(
    fullBuildURL(`/api/v1/dashboard/sites/${payload.siteId}/widgets/${payload.widgetId}`)
  );
};
